var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5286 6.74754C11.7889 6.48719 11.7889 6.06508 11.5286 5.80473C11.2682 5.54438 10.8461 5.54438 10.5858 5.80473L7.5286 8.86192L4.4714 5.80473C4.21105 5.54438 3.78895 5.54438 3.52859 5.80473C3.26825 6.06508 3.26825 6.48719 3.5286 6.74754L7.5286 10.7475L11.5286 6.74754Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrow);
export default __webpack_public_path__ + "static/media/smallArrow.719fcd3f0e61c21c78de0f85805f3aba.svg";
export { ForwardRef as ReactComponent };